var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-offline-dialog',{attrs:{"dialog":_vm.offLineDialog},on:{"handleOfflineDialog":_vm.handleOfflineDialog}}),_c('router-view',{attrs:{"fluid":_vm.fluid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }